import {Amplify} from 'aws-amplify';
import {getUrl, GetUrlWithPathOutput} from 'aws-amplify/storage';
import awsconfig from '../amplifyconfiguration.json';

export const getFileUrlByKey = async (
  path: string,
  customBucketName?: string,
): Promise<GetUrlWithPathOutput> => {

  try {
    // Configure Amplify with custom bucket if specified
    if (customBucketName) {
      Amplify.configure({
        ...awsconfig,
        // @ts-ignore - TS doesn't recognize this property
        aws_user_files_s3_bucket: customBucketName,
      });
    } else {
      // Use default configuration
      Amplify.configure(awsconfig);
    }

    const encodedPath = decodeURIComponent(path).replace(/\+/g, " ");

    const result: GetUrlWithPathOutput = await getUrl({
      path: encodedPath,
      options: {
        validateObjectExistence: true,
        expiresIn: 3600, // validity of the URL, in seconds. defaults to 900 (15 minutes) and maxes at 3600 (1 hour)
      },
    });


    return result;
  } catch (error: unknown) {

    // Log more details about the error
    if (error instanceof Error) {
      console.error('Error name:', error.name);
      console.error('Error message:', error.message);
    }

    // Re-throw the error so the caller can handle it appropriately
    throw error;
  }
};
